import { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const { data, error } = await supabase.auth.resetPasswordForEmail(email, { 
      redirectTo: 'https://nargklab.com/reset-password'
    });

    if (error) {
      setError(error.message);
    } else {
      setError('If an account exists, a reset email was sent.');
    }
    setLoading(false);
  };

  return (
    <section className="section is-fullheight has-background-light">
      <div className="container">
            <div className="box p-5" style={{width: '400px', margin: 'auto'}}>
              <h1 className="title has-text-centered mb-5">Reset Password</h1>
              {error && (
                <div className="notification is-success">
                  <button className="delete" onClick={() => setError(null)}></button>
                  {error}
                </div>
              )}
              <form onSubmit={handlePasswordReset}>
                <div className="field mb-4">
                  <label className="label" htmlFor="email-login">Email</label>
                  <div className="control has-icons-left">
                    <input
                      className="input"
                      type="email"
                      id="email-login"
                      placeholder="e.g. alex@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={loading}
                      required
                    />
                    <span className="icon is-small is-left">
                      <i className="fas fa-envelope"></i>
                    </span>
                  </div>
                </div>

                <div className="field mt-5">
                  <button
                    className={`button is-primary is-fullwidth ${loading ? 'is-loading' : ''}`}
                    type="submit"
                    disabled={loading}
                  >
                    <span className="icon is-small is-left">
                      <i className="fas fa-arrow-right"></i>
                    </span>
                    <span>Reset Password</span>
                  </button>
                </div>
              </form>

              <p className="has-text-centered mt-5">
                Remembered password? <Link to="/login">Log In</Link>
              </p>
            </div>
          </div>
    </section>
  );
};

export default ForgotPasswordPage;